(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu is now handled by global.js setupMobileMenu()
  // This file only contains section-specific JavaScript if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelector('[data-sort-select]')?.addEventListener('change', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // Thumbnail click
  document.querySelectorAll('[data-thumbnail]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.mediaSrc;
      const mainImage = document.getElementById('ProductImage');
      
      if (mainImage && src) {
        mainImage.src = src;
        document.querySelectorAll('[data-thumbnail]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      }
    });
  });

  // Quantity buttons
  const quantityInput = document.querySelector('[data-quantity-input]');
  const quantityHidden = document.querySelector('[data-quantity-value]');
  
  function syncQuantity() {
    if (quantityInput && quantityHidden) {
      quantityHidden.value = quantityInput.value;
    }
  }

  if (quantityInput) {
    quantityInput.addEventListener('change', syncQuantity);
  }
  
  document.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    const current = parseInt(quantityInput.value) || 1;
    if (current > 1) {
      quantityInput.value = current - 1;
      syncQuantity();
    }
  });

  document.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    const current = parseInt(quantityInput.value) || 1;
    quantityInput.value = current + 1;
    syncQuantity();
  });

  // Variant selection - update price, quote button, hidden input, and SKU display
  const optionSelects = document.querySelectorAll('[data-option-select]');
  const variantInput = document.querySelector('input[name="id"]');
  const quoteButton = document.querySelector('[data-add-to-quote]');
  const skuDisplay = document.querySelector('[data-product-sku]');
  const priceWrapper = document.querySelector('[data-price-wrapper]');
  const priceRegular = document.querySelector('[data-price-regular]');
  const priceCompare = document.querySelector('[data-price-compare]');
  const comparePrice = document.querySelector('[data-compare-price]');
  const pricePrefix = document.querySelector('[data-price-prefix]');
  const soldOutBadge = document.querySelector('[data-sold-out-badge]');
  const saleBadge = document.querySelector('[data-sale-badge]');
  const addToCartButton = document.querySelector('[name="add"]');
  
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }
  
  if (optionSelects.length && window.productVariants) {
    optionSelects.forEach((select) => {
      select.addEventListener('change', () => {
        const selectedOptions = Array.from(optionSelects).map((s) => s.value);
        const variant = window.productVariants.find((v) => {
          return v.options.every((opt, i) => opt === selectedOptions[i]);
        });
        
        if (variant) {
          // Update hidden variant input
          if (variantInput) {
            variantInput.value = variant.id;
          }
          
          // Update price display
          if (priceRegular) {
            priceRegular.textContent = formatMoney(variant.price);
          }
          
          // Hide "From" prefix when variant is selected
          if (pricePrefix) {
            pricePrefix.style.display = 'none';
          }
          
          // Handle compare at price
          const hasComparePrice = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (priceCompare) {
            priceCompare.style.display = hasComparePrice ? '' : 'none';
          }
          if (comparePrice && hasComparePrice) {
            comparePrice.textContent = formatMoney(variant.compare_at_price);
          }
          
          // Update price wrapper classes
          if (priceWrapper) {
            priceWrapper.classList.toggle('price--on-sale', hasComparePrice);
            priceWrapper.classList.toggle('price--sold-out', !variant.available);
            priceWrapper.classList.remove('price--varies');
          }
          
          // Update badges
          if (soldOutBadge) {
            soldOutBadge.style.display = variant.available ? 'none' : '';
          }
          if (saleBadge) {
            saleBadge.style.display = hasComparePrice && variant.available ? '' : 'none';
          }
          
          // Update add to cart button
          if (addToCartButton) {
            addToCartButton.disabled = !variant.available;
            addToCartButton.textContent = variant.available ? 
              (addToCartButton.dataset.addText || 'Add to Cart') : 
              (addToCartButton.dataset.soldOutText || 'Sold Out');
          }
          
          // Update SKU display
          if (skuDisplay) {
            skuDisplay.textContent = variant.sku || 'N/A';
          }
          
          // Update quote button data attributes
          if (quoteButton) {
            quoteButton.dataset.variantId = variant.id;
            quoteButton.dataset.variantTitle = variant.title;
            quoteButton.dataset.productPrice = variant.price;
            quoteButton.dataset.productPriceFormatted = formatMoney(variant.price);
            quoteButton.dataset.productSku = variant.sku || '';
          }
          
          // Update URL with variant
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-quote"]) return;
  try {
    
  class QuotePage {
    constructor() {
      this.container = document.querySelector('[data-quote-page]');
      if (!this.container) return;

      this.emptyState = this.container.querySelector('[data-quote-page-empty]');
      this.contentState = this.container.querySelector('[data-quote-page-content]');
      this.tableBody = this.container.querySelector('[data-quote-table-body]');
      this.totalItemsEl = this.container.querySelector('[data-quote-total-items]');
      this.uniqueItemsEl = this.container.querySelector('[data-quote-unique-items]');
      this.clearBtn = this.container.querySelector('[data-quote-clear]');

      this.init();
    }

    init() {
      // Listen for quote updates
      document.addEventListener('quote:updated', () => this.render());
      document.addEventListener('quote:loaded', () => this.render());

      // Clear all button
      this.clearBtn?.addEventListener('click', () => {
        const confirmText = this.clearBtn.dataset.confirmText || 'Are you sure you want to clear all items from your quote?';
        if (confirm(confirmText)) {
          window.quoteManager?.clear();
        }
      });

      // Delegated events for table actions
      this.tableBody?.addEventListener('click', (e) => {
        const target = e.target.closest('[data-action]');
        if (!target) return;

        const action = target.dataset.action;
        const variantId = target.dataset.variantId;

        if (action === 'remove') {
          window.quoteManager?.remove(variantId);
        } else if (action === 'increase') {
          const item = window.quoteManager?.items.find((i) => window.quoteManager?.getItemKey(i) === variantId);
          if (item) {
            window.quoteManager?.update(variantId, item.quantity + 1);
          }
        } else if (action === 'decrease') {
          const item = window.quoteManager?.items.find((i) => window.quoteManager?.getItemKey(i) === variantId);
          if (item && item.quantity > 1) {
            window.quoteManager?.update(variantId, item.quantity - 1);
          }
        }
      });

      // Quantity input change
      this.tableBody?.addEventListener('change', (e) => {
        if (e.target.matches('[data-quantity-input]')) {
          const variantId = e.target.dataset.variantId;
          const quantity = parseInt(e.target.value) || 1;
          window.quoteManager?.update(variantId, Math.max(1, quantity));
        }
      });

      // Initial render
      this.render();
    }

    render() {
      const items = window.quoteManager?.getItems() || [];
      
      if (items.length === 0) {
        this.emptyState?.removeAttribute('hidden');
        this.contentState?.setAttribute('hidden', '');
        return;
      }

      this.emptyState?.setAttribute('hidden', '');
      this.contentState?.removeAttribute('hidden');

      // Update summary
      if (this.totalItemsEl) {
        this.totalItemsEl.textContent = window.quoteManager?.getItemCount() || 0;
      }
      if (this.uniqueItemsEl) {
        this.uniqueItemsEl.textContent = window.quoteManager?.getUniqueItemCount() || 0;
      }

      // Render table rows
      if (this.tableBody) {
        this.tableBody.innerHTML = items.map((item) => {
          const itemKey = window.quoteManager?.getItemKey(item);
          return `
          <tr>
            <td class="main-quote__item-image">
              ${item.image 
                ? `<img src="${item.image}" alt="${this.escapeHtml(item.title)}" loading="lazy">`
                : `<div class="main-quote__item-placeholder"></div>`
              }
            </td>
            <td class="main-quote__item-details">
              <a href="${item.url}" class="main-quote__item-title">${this.escapeHtml(item.title)}</a>
              ${item.variantTitle && item.variantTitle !== 'Default Title' 
                ? `<span class="main-quote__item-variant">${this.escapeHtml(item.variantTitle)}</span>` 
                : ''
              }
            </td>
            <td class="main-quote__item-sku">${item.sku ? this.escapeHtml(item.sku) : '—'}</td>
            <td class="main-quote__item-quantity">
              <div class="main-quote__quantity-wrapper">
                <button type="button" class="main-quote__quantity-btn" data-action="decrease" data-variant-id="${itemKey}" aria-label="Decrease quantity">−</button>
                <input type="number" class="main-quote__quantity-input" value="${item.quantity}" min="1" data-quantity-input data-variant-id="${itemKey}">
                <button type="button" class="main-quote__quantity-btn" data-action="increase" data-variant-id="${itemKey}" aria-label="Increase quantity">+</button>
              </div>
            </td>
            <td>
              <button type="button" class="main-quote__remove-btn" data-action="remove" data-variant-id="${itemKey}" aria-label="Remove ${this.escapeHtml(item.title)}">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </td>
          </tr>
        `;
        }).join('');
      }
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    new QuotePage();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
  // Populate quote form with items from localStorage
  class QuoteFormPopulator {
    constructor() {
      this.form = document.querySelector('[data-quote-form]');
      if (!this.form) return;
      
      this.listContainer = this.form.querySelector('[data-quote-list-container]');
      this.listItems = this.form.querySelector('[data-quote-list-items]');
      this.itemsDataField = document.getElementById('quote-items-data');
      this.itemsSummaryField = document.getElementById('quote-items-summary');
      
      this.init();
    }
    
    init() {
      document.addEventListener('DOMContentLoaded', () => this.populate());
      document.addEventListener('quote:loaded', () => this.populate());
      document.addEventListener('quote:updated', () => this.populate());
      
      // Delegated event listeners for quantity and remove actions
      this.listItems?.addEventListener('click', (e) => {
        const target = e.target.closest('[data-action]');
        if (!target) return;

        const action = target.dataset.action;
        const variantId = target.dataset.variantId;

        if (action === 'remove') {
          window.quoteManager?.remove(variantId);
        } else if (action === 'increase') {
          const item = window.quoteManager?.items.find((i) => i.variantId === variantId);
          if (item) {
            window.quoteManager?.update(variantId, item.quantity + 1);
          }
        } else if (action === 'decrease') {
          const item = window.quoteManager?.items.find((i) => i.variantId === variantId);
          if (item && item.quantity > 1) {
            window.quoteManager?.update(variantId, item.quantity - 1);
          } else if (item && item.quantity <= 1) {
            window.quoteManager?.remove(variantId);
          }
        }
      });
    }
    
    populate() {
      const items = window.quoteManager?.getItems() || [];
      
      if (items.length === 0) {
        this.listContainer?.setAttribute('hidden', '');
        return;
      }
      
      // Show the quote list container
      this.listContainer?.removeAttribute('hidden');
      
      // Populate hidden fields with quote data
      if (this.itemsDataField && window.quoteManager) {
        this.itemsDataField.value = window.quoteManager.getItemsJSON();
      }
      
      if (this.itemsSummaryField && window.quoteManager) {
        this.itemsSummaryField.value = window.quoteManager.getItemsSummary();
      }
      
      // Render quote items
      if (this.listItems) {
        this.listItems.innerHTML = items.map((item) => `
          <div class="quote-form__quote-item" data-variant-id="${item.variantId}">
            <div class="quote-form__quote-item-image">
              ${item.image 
                ? `<img src="${item.image}" alt="${this.escapeHtml(item.title)}" loading="lazy">`
                : ''
              }
            </div>
            <div class="quote-form__quote-item-info">
              <p class="quote-form__quote-item-title">${this.escapeHtml(item.title)}</p>
              ${item.variantTitle && item.variantTitle !== 'Default Title' 
                ? `<span class="quote-form__quote-item-variant">${this.escapeHtml(item.variantTitle)}</span>` 
                : ''
              }
            </div>
            <div class="quote-form__quote-item-quantity">
              <button type="button" class="quote-form__qty-btn" data-action="decrease" data-variant-id="${item.variantId}" aria-label="Decrease quantity">−</button>
              <span class="quote-form__qty-value">${item.quantity}</span>
              <button type="button" class="quote-form__qty-btn" data-action="increase" data-variant-id="${item.variantId}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="quote-form__item-remove" data-action="remove" data-variant-id="${item.variantId}" aria-label="Remove ${this.escapeHtml(item.title)}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        `).join('');
      }
    }
    
    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }
  
  // Initialize
  new QuoteFormPopulator();

  } catch(e) { console.error(e); }
})();
})();
